import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import SubscriptionForm from './SubscriptionForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import subscriptionService from './subscriptionService';

const SubscriptionEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [entity, setEntity] = useState<any>({
    name: '',
    tenantId: '',
    licenseId: '',
    paymentOccurrence: 'Monthly',
    status: 1,
    startsAt: '',
    endsAt: '',
  });
  const { canPlatform } = useCheckPermission();

  useEffect(() => {
    subscriptionService.get(params.id).then((response: any) => {
      if (response.hasError) {
        setErrors(response.errorMessages ?? []);
        enqueueSnackbar((response.errorMessages ?? []).join(','), {
          variant: 'error',
        });
      } else {
        setEntity(response.result);
      }
    });
  }, [params.id]);

  const onSubmit = (values: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    subscriptionService
      .update({
        ...values,
        startsAt: values.startsAt || null,
        endsAt: values.endsAt || null,
      })
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', { variant: 'success' });
          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <SubscriptionForm
      entity={entity}
      readonly={!canPlatform(['ManageSubscriptions'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
    />
  );
};

export default SubscriptionEdit;
